﻿'use strict';

angular.module('ntmApp').factory('LocationTilesViewModel', ['$q', 'DailyPlanService', 'NonDailyActivities', function ($q, DailyPlanService, NonDailyActivities) {

    function LocationTilesViewModel(context) {

        var self = this;
        var tileList = [];

        self.load = function () {

            self.isLoading = true;

            loadTiles().then(function () {
                self.isLoading = false;
                self.performFiltering();
            });

            loadStatistics();

            self.NonDailyActivities.load();
        };

        self.performFiltering = function () {
            if (context.TopBar.BreadCrumbs.showEmergency) {
                return;
            }
            if (context.TopBar.BreadCrumbs.selectedViewType.schedulers.filter(function (scheduler) { return scheduler.selected; }).length === 0) {
                self.tiles = angular.copy(tileList);
            } else {
                self.tiles = angular.copy(tileList.filter(function (tile) {
                    return context.TopBar.BreadCrumbs.selectedViewType.schedulers.filter(function (scheduler) {
                        return tile.primarySchedulers.filter(function (tileScheduler) {
                            return scheduler.selected && tileScheduler.id === scheduler.id;
                        }).length > 0;
                    }).length > 0;
                }));
            }
        };

        self.showRooms = function (locationId) {

            var request = context.getViewModeAndSelectedDate();

            self.isLoading = true;

            DailyPlanService.GetBreadcrumb(request).then(function (result) {
                context.TopBar.BreadCrumbs.setLocations(result.data);
                context.TopBar.BreadCrumbs.changeLocationById(locationId);
            });
        };

        self.getStaff = function (staffList) {

            return staffList.length > 0 ? staffList.map(function (item) { return item.value; })
                .sort(function (a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                }).join(',') : '';
        };

        self.noRecordsMessage = function () {
            return 'No records found';
        };

        self.showUnplanedActivitiesButton = function (button) {
            

            if (!button.jsonProperties || !button.jsonProperties.display) {
                return true;
            }

            return button.jsonProperties.display.level1;
        };

        self.toggleStatistics = function () {
            self.showStatistics = !self.showStatistics;
            self.showNonDailyActivities = false;

            saveRightPanesState();
        };

        self.toggleNonDailyActivities = function() {
            self.showNonDailyActivities = !self.showNonDailyActivities;
            self.showStatistics = false;

            saveRightPanesState();
        };

        self.isRightPanelOpened = function () {
            return self.showStatistics || self.showNonDailyActivities;
        };

        self.updateViewOnWebSocketsResponse = function (callBackData) {

            var dateDisplayed = moment(context.TopBar.dateDisplayed).startOf('day');
            var socketDate = moment(callBackData.date).startOf('day');

            if (dateDisplayed.isSame(socketDate)) {
                
                var tilesToUpdate = self.tiles.filter(function (tile) {
                    var callBackFacilityMatched = callBackData.dailySocketFacilities.firstOrDefault(function (facility) {
                        return tile.roomNumbers.some(function (facilityCode) {
                            return facilityCode.facilityCode === facility.facilityCode;
                        });
                    });

                    if (callBackFacilityMatched) {
                        return tile;
                    }
                    return false;
                });

                if (tilesToUpdate && tilesToUpdate.length > 0) {

                    tilesToUpdate.forEach(function (tile) {
                        tile.tileChanging = true;
                    });

                    var request = context.getViewModeAndSelectedDate();

                    DailyPlanService.GetTiles(request).then(function (result) {

                        tilesToUpdate.forEach(function (tile) {

                            var newTile = result.data.tiles.firstOrDefault(function (item) {
                                return item.id === tile.id;
                            });

                            if (newTile) {
                                tile.unassignedMinutes = newTile.unassignedMinutes;
                                tile.overAllocatedMinutes = newTile.overAllocatedMinutes;
                                tile.underAllocatedMinutes = newTile.underAllocatedMinutes;
                                tile.roomNumbers = newTile.roomNumbers;
                                tile.rooms = newTile.rooms;
                            }

                            tile.tileChanging = false;
                        });
                    });

                    loadStatistics();
                    self.NonDailyActivities.load();
                }

            }
        };

        self.confirmViewLeaving = function (nextAction) {

            if (nextAction) {
                nextAction();
            }
        };

        self.isChanged = function () {
            return false;
        };

        self.areFiltersApplied = function () {
            var filtersApplied = false;

            for (var option in self.selectedFilterOptions) {

                if (self.selectedFilterOptions.hasOwnProperty(option) && self.selectedFilterOptions[option]) {

                    if (self.selectedFilterOptions[option]) {
                        filtersApplied = true;

                        break;
                    }
                }
            }

            if (filtersApplied) {
                return true;
            }

            return false;
        };

        self.clearAllFilters = function () {

            self.selectedFilterOptions = {};

            self.performFiltering();
        };

        function initialize() {

            self.NonDailyActivities = new NonDailyActivities(context);
            self.filtersDataSource = {};
            self.selectedFilterOptions = {};

            self.showStatistics = sessionStorage.showDailyPlanStatisticsPane ? true : false;
            self.showNonDailyActivities = sessionStorage.showDailyPlanNonDailyActivitiesPane ? true : false;
        }

        function loadTiles() {

            var deferred = $q.defer();
            var request = context.getViewModeAndSelectedDate();

            DailyPlanService.GetTiles(request).then(function (result) {
                self.tiles = angular.copy(result.data.tiles);
                tileList = angular.copy(result.data.tiles);
                deferred.resolve();
            });

            return deferred.promise;
        }

        function loadStatistics() {

            var request = context.getViewModeAndSelectedDate();

            self.statisticChanging = true;
            DailyPlanService.GetStatistics(request).then(function (result) {
                self.statistic = result.data;
                self.statisticChanging = false;
            });
        }

        function saveRightPanesState() {
            sessionStorage.showDailyPlanStatisticsPane = self.showStatistics || "";
            sessionStorage.showDailyPlanNonDailyActivitiesPane = self.showNonDailyActivities || "";
        }

        initialize();
    }

    return (LocationTilesViewModel);

}]);